<div class="modal-container">
  <!-- Modal Header with Brand Shell and Title -->
  <div class="modal-header">
    <div class="header-title">
      <div class="icon-shell">
        <i-tabler [name]="modalIcon" class="title-icon"></i-tabler>
      </div>
      <div class="header-text">
        <span class="eyebrow-pill">SERVICIOS OPERATIVOS</span>
        <h2>{{ modalTitle }}</h2>
      </div>
    </div>
    <button
      mat-icon-button
      type="button"
      class="close-btn"
      (click)="handleCloseModal()"
      matTooltip="Cerrar modal"
    >
      <i-tabler name="x"></i-tabler>
    </button>
  </div>

  <!-- Modal Body -->
  <mat-dialog-content class="modal-body">
    <!-- File Context Information Card -->
    <div class="file-summary-card">
      <div class="summary-item summary-file">
        <i-tabler name="folder" class="summary-icon"></i-tabler>
        <span class="label">File:</span>
        <span class="value file-badge">{{
          modalInjectData.picnicItemRow.fileNumber
        }}</span>
      </div>
      <div
        class="summary-item"
        *ngIf="modalInjectData.picnicItemRow.nombreItinerario"
      >
        <i-tabler name="route" class="summary-icon"></i-tabler>
        <span class="label">Itinerario:</span>
        <span class="value">{{
          modalInjectData.picnicItemRow.nombreItinerario
        }}</span>
      </div>
      <div class="summary-item">
        <i-tabler name="user" class="summary-icon"></i-tabler>
        <span class="label">Cliente:</span>
        <span class="value">{{
          modalInjectData.picnicItemRow.nameClient
        }}</span>
      </div>
      <div class="summary-item">
        <i-tabler name="calendar" class="summary-icon"></i-tabler>
        <span class="label">F. Operación:</span>
        <span class="value">{{ formattedOperationDate }}</span>
      </div>
      <div class="summary-item" *ngIf="activityName">
        <i-tabler name="walk" class="summary-icon"></i-tabler>
        <span class="label">Actividad:</span>
        <span class="value">{{ activityName }}</span>
      </div>
    </div>

    <!-- Loading State -->
    <div class="modal-loading-state" *ngIf="isLoadingServices">
      <mat-spinner diameter="36"></mat-spinner>
      <span>Cargando servicios operativos...</span>
    </div>

    <!-- Error State -->
    <div class="modal-error-state" *ngIf="!isLoadingServices && errorMessage">
      <i-tabler name="alert-circle"></i-tabler>
      <span>{{ errorMessage }}</span>
      <button
        mat-stroked-button
        type="button"
        class="btn-retry"
        (click)="loadOperationalServicesOnDemand()"
      >
        <i-tabler name="reload"></i-tabler>
        <span>Reintentar</span>
      </button>
    </div>

    <!-- Main Content when not loading and no error -->
    <ng-container *ngIf="!isLoadingServices && !errorMessage">
      <!-- Unified Action Bar -->
      <div class="bulk-action-bar" *ngIf="servicesList.length > 0">
        <!-- Multiple Services: Selection Controls -->
        <div class="selection-controls" *ngIf="servicesList.length > 1">
          <label
            class="select-all-label"
            [class.is-disabled]="selectableServicesCount === 0"
          >
            <mat-checkbox
              [checked]="areAllServicesSelected()"
              [indeterminate]="isSelectionIndeterminate()"
              [disabled]="selectableServicesCount === 0"
              (change)="toggleSelectAllServices()"
              color="primary"
              class="select-all-checkbox"
            ></mat-checkbox>
            <span
              class="checkbox-label-text"
              *ngIf="selectableServicesCount > 0"
            >
              {{
                areAllServicesSelected()
                  ? "Deseleccionar todos"
                  : "Seleccionar todos"
              }}
            </span>
            <span
              class="checkbox-label-text disabled-label"
              *ngIf="selectableServicesCount === 0"
            >
              {{
                allServicesHaveOrders
                  ? "Todos con OS generada"
                  : "Servicios de Salida Fija (SSFF)"
              }}
            </span>
          </label>

          <span
            class="selection-counter-badge"
            *ngIf="selectedServicesCount > 0"
          >
            <strong>{{ selectedServicesCount }}</strong> de
            {{ selectableServicesCount }} disponible(s)
          </span>
        </div>

        <!-- Single Service: Subtle Context Hint -->
        <div class="single-service-prompt" *ngIf="servicesList.length === 1">
          <span
            class="prompt-badge locked"
            *ngIf="hasServiceOrder(servicesList[0])"
            matTooltip="La Orden de Servicio ya ha sido generada"
          >
            <i-tabler name="lock"></i-tabler>
            <span>Con OS generada</span>
          </span>
          <span
            class="prompt-badge locked ssff-locked"
            *ngIf="
              !hasServiceOrder(servicesList[0]) &&
              isSsffBlocked(servicesList[0])
            "
            matTooltip="Servicio de Salida Fija (SSFF): no editable"
          >
            <i-tabler name="lock"></i-tabler>
            <span>Servicio SSFF</span>
          </span>
          <span
            class="prompt-badge"
            *ngIf="isServiceSelectable(servicesList[0])"
          >
            1 servicio disponible
          </span>
        </div>

        <!-- Action Buttons -->
        <div class="action-buttons-group">
          <button
            mat-flat-button
            type="button"
            class="btn-bulk-provider"
            [disabled]="!canChangeProviderForSelection"
            (click)="handleOpenChangeProviderForSelected()"
            [matTooltip]="changeProviderTooltipText"
          >
            <i-tabler name="pencil"></i-tabler>
            <span>Seleccionar Proveedor</span>
            <span class="count-pill" *ngIf="selectedServicesCount > 1">
              {{ selectedServicesCount }}
            </span>
          </button>

          <button
            mat-stroked-button
            type="button"
            class="btn-bulk-os"
            [disabled]="!canGenerateOrderForSelection"
            (click)="handleOpenCreateOrderForSelected()"
            [matTooltip]="orderGenerationTooltipText"
          >
            <i-tabler name="file-text"></i-tabler>
            <span>Generar OS</span>
            <span
              class="count-pill-neutral"
              *ngIf="selectedServicesEligibleForOrderCount > 1"
            >
              {{ selectedServicesEligibleForOrderCount }}
            </span>
          </button>
        </div>
      </div>

      <!-- Services Grid List -->
      <div
        class="services-grid"
        *ngIf="servicesList.length > 0; else emptyState"
      >
        <div
          class="service-card"
          *ngFor="let serviceItem of servicesList; let serviceIndex = index"
          [class.is-selected]="isServiceSelected(serviceItem.id)"
          [class.is-locked]="!isServiceSelectable(serviceItem)"
          [class.is-ssff-blocked]="isSsffBlocked(serviceItem)"
          [class.has-order-active]="
            !isSsffBlocked(serviceItem) && hasServiceOrder(serviceItem)
          "
          [class.is-pending-os]="isServiceSelectable(serviceItem)"
          (click)="
            isServiceSelectable(serviceItem) && servicesList.length > 1
              ? toggleServiceSelection(serviceItem)
              : null
          "
        >
          <!-- Card Top Header Row: Slot/Check on Left, OS info on Right -->
          <div class="card-top-row">
            <div class="slot-and-check">
              <mat-checkbox
                *ngIf="
                  isServiceSelectable(serviceItem) && servicesList.length > 1
                "
                [checked]="isServiceSelected(serviceItem.id)"
                (click)="$event.stopPropagation()"
                (change)="toggleServiceSelection(serviceItem)"
                color="primary"
                class="card-select-checkbox"
              ></mat-checkbox>
              <div
                class="lock-indicator"
                *ngIf="!isServiceSelectable(serviceItem)"
                [matTooltip]="
                  isSsffBlocked(serviceItem)
                    ? 'Servicio no editable: Pertenece a Salida Fija (SSFF)'
                    : 'Servicio bloqueado: Ya cuenta con Orden de Servicio generada'
                "
              >
                <i-tabler name="lock" class="lock-icon"></i-tabler>
              </div>
              <span class="card-slot-badge">
                {{
                  servicesList.length > 1
                    ? "Servicio #" + (serviceIndex + 1)
                    : "Servicio Asignado"
                }}
              </span>
              <span
                class="ssff-pill-badge"
                *ngIf="showSsffChip(serviceItem)"
                matTooltip="Servicio perteneciente a Salida Fija (SSFF)"
                >SSFF</span
              >
              <span
                class="ssff-pill-badge upgrade"
                *ngIf="showUpgradeChip(serviceItem)"
                matTooltip="Servicio Upgrade exclusivo"
                >Upgrade</span
              >
            </div>

            <!-- Top-Right OS Status & Mini Actions -->
            <div class="card-os-header-slot">
              <!-- CASE 1: Service is SSFF Blocked on Child File -->
              <div
                class="card-os-tag ssff-locked-tag"
                *ngIf="isSsffBlocked(serviceItem)"
                matTooltip="Servicio de Salida Fija (SSFF): administrado por el File Padre"
              >
                <i-tabler name="lock" class="empty-icon"></i-tabler>
                <span>SSFF</span>
              </div>

              <!-- CASE 2: Operable Service Has Active Order -->
              <div
                class="service-doc-group service-doc-group--os"
                [class.service-doc-group--preliminar]="
                  isServiceOrderPreliminary(serviceItem)
                "
                *ngIf="
                  !isSsffBlocked(serviceItem) && hasServiceOrder(serviceItem)
                "
              >
                <span class="service-doc-group__label" aria-hidden="true"
                  >OS</span
                >
                <div class="service-doc-group__actions">
                  <button
                    *ngIf="canShowServiceOrderPdf(serviceItem)"
                    type="button"
                    class="service-doc-action"
                    [class.service-doc-action--pdf-ready]="
                      isServicePdfReady(serviceItem.order?.pdfStatus)
                    "
                    [class.service-doc-action--pdf-muted]="
                      !isServicePdfReady(serviceItem.order?.pdfStatus)
                    "
                    matTooltip="Ver PDF de la Orden de Servicio"
                    aria-label="Ver PDF OS"
                    (click)="handleViewOrderPdf(serviceItem, $event)"
                  >
                    <i-tabler
                      name="file-type-pdf"
                      class="service-doc-action__icon"
                    ></i-tabler>
                  </button>

                  <button
                    *ngIf="isServiceOrderPreliminary(serviceItem)"
                    type="button"
                    class="service-doc-action service-doc-action--confirm"
                    matTooltip="Confirmar OS"
                    aria-label="Confirmar OS"
                    (click)="handleConfirmPreliminaryOrder(serviceItem, $event)"
                  >
                    <i-tabler
                      name="circle-check"
                      class="service-doc-action__icon"
                    ></i-tabler>
                  </button>

                  <button
                    *ngIf="hasServiceOrder(serviceItem)"
                    type="button"
                    class="service-doc-action"
                    matTooltip="Historial de recálculo"
                    aria-label="Historial de recálculo"
                    (click)="handleOpenRecalcHistory(serviceItem, $event)"
                  >
                    <i-tabler
                      name="history"
                      class="service-doc-action__icon"
                    ></i-tabler>
                  </button>

                  <button
                    *ngIf="isServiceOrderDeletable(serviceItem)"
                    type="button"
                    class="service-doc-action service-doc-action--danger"
                    matTooltip="Eliminar Orden de Servicio"
                    aria-label="Eliminar OS"
                    (click)="handleDeleteOrder(serviceItem, $event)"
                  >
                    <i-tabler
                      name="trash"
                      class="service-doc-action__icon"
                    ></i-tabler>
                  </button>
                </div>

                <button
                  *ngIf="isServiceOrderPreliminary(serviceItem)"
                  type="button"
                  class="service-doc-corte"
                  matTooltip="Cambiar el plazo para confirmar"
                  (click)="handleOpenFreezeDeadline(serviceItem, $event)"
                >
                  <i-tabler
                    name="calendar"
                    class="service-doc-corte__icon"
                  ></i-tabler>
                  <span>
                    <small>Confirmar antes del</small>
                    <strong>{{
                      resolveFreezeDeadlineDisplay(serviceItem)
                    }}</strong>
                  </span>
                </button>
              </div>

              <!-- CASE 3: Operable Service Has NO Active Order -->
              <div
                class="card-os-tag no-order"
                *ngIf="
                  !isSsffBlocked(serviceItem) && !hasServiceOrder(serviceItem)
                "
                matTooltip="Sin Orden de Servicio generada"
              >
                <i-tabler name="file-off" class="empty-icon"></i-tabler>
                <span>Sin OS</span>
              </div>
            </div>
          </div>

          <!-- Service Main Details -->
          <div class="card-details">
            <h4 class="service-name">{{ serviceItem.nombreServicio }}</h4>

            <!-- Provider Assignment Row -->
            <div class="field-section">
              <span class="field-label">Proveedor</span>
              <div
                class="provider-value-box"
                [class.has-provider]="!!serviceItem.nombreProveedor"
              >
                <div class="prov-icon-shell">
                  <i-tabler name="building-store" class="prov-icon"></i-tabler>
                </div>
                <span
                  class="prov-text"
                  [class.no-provider]="!serviceItem.nombreProveedor"
                  [matTooltip]="serviceItem.nombreProveedor || ''"
                >
                  {{ serviceItem.nombreProveedor || "Sin proveedor asignado" }}
                </span>
              </div>
            </div>

            <!-- CASE 1: Order Details Section (when OS generated on operable service) -->
            <div
              class="order-info-section"
              *ngIf="
                !isSsffBlocked(serviceItem) && hasServiceOrder(serviceItem)
              "
            >
              <div class="order-status-row">
                <span
                  class="order-chip"
                  [class.order-chip--preliminar]="
                    resolveServiceOrderStatus(serviceItem) === 'PRELIMINAR'
                  "
                  [class.order-chip--confirmado]="
                    resolveServiceOrderStatus(serviceItem) === 'CONFIRMADO'
                  "
                  [class.order-chip--proceso]="
                    resolveServiceOrderStatus(serviceItem) === 'EN PROCESO'
                  "
                  [class.order-chip--procesado]="
                    resolveServiceOrderStatus(serviceItem) === 'PROCESADO'
                  "
                >
                  <i-tabler name="file-invoice" class="chip-icon"></i-tabler>
                  <span class="chip-number"
                    >OS {{ resolveServiceOrderNumber(serviceItem) || "—" }}</span
                  >
                </span>
                <span
                  class="os-status"
                  [attr.data-os-status]="
                    (resolveServiceOrderStatus(serviceItem) || '').toUpperCase()
                  "
                >
                  {{ resolveServiceOrderStatus(serviceItem) }}
                </span>
              </div>

              <div class="payment-date-row">
                <div class="payment-date-info">
                  <i-tabler name="calendar-time" class="date-icon"></i-tabler>
                  <span class="date-label">Pago prog.:</span>
                  <strong class="date-value">{{
                    resolveScheduledPaymentDateDisplay(serviceItem)
                  }}</strong>
                </div>

                <button
                  type="button"
                  class="btn-edit-payment-date"
                  [disabled]="!isServiceOrderEditable(serviceItem)"
                  [matTooltip]="
                    isSsffBlocked(serviceItem)
                      ? 'No editable: servicio de Salida Fija gestionado desde el File Padre'
                      : isServiceOrderEditable(serviceItem)
                        ? 'Editar fecha de pago programada'
                        : 'No editable en estado ' +
                          resolveServiceOrderStatus(serviceItem)
                  "
                  (click)="
                    handleOpenEditScheduledPaymentDate(serviceItem, $event)
                  "
                >
                  <i-tabler name="pencil" class="edit-icon"></i-tabler>
                </button>
              </div>
            </div>

            <!-- CASE 2: Pending OS Footer Slot (when Operable but No OS generated yet) -->
            <div
              class="pending-os-footer-slot"
              *ngIf="
                !isSsffBlocked(serviceItem) && !hasServiceOrder(serviceItem)
              "
            >
              <div
                class="pending-status-pill"
                [class.ready-to-generate]="!!serviceItem.nombreProveedor"
                [class.needs-provider]="!serviceItem.nombreProveedor"
              >
                <i-tabler
                  [name]="
                    serviceItem.nombreProveedor
                      ? 'circle-check'
                      : 'alert-circle'
                  "
                  class="pending-pill-icon"
                ></i-tabler>
                <span>
                  {{
                    serviceItem.nombreProveedor
                      ? "Listo para generar OS"
                      : "Requiere asignar proveedor"
                  }}
                </span>
              </div>
            </div>

            <!-- CASE 3: SSFF Blocked Footer Slot (when Child File SSFF) -->
            <div
              class="ssff-blocked-footer-slot"
              *ngIf="isSsffBlocked(serviceItem)"
            >
              <div class="ssff-blocked-pill">
                <i-tabler name="lock" class="ssff-pill-icon"></i-tabler>
                <span>Gestionado desde File Padre</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <ng-template #emptyState>
        <div class="empty-state-box">
          <i-tabler name="search-off" class="empty-icon"></i-tabler>
          <h4>No se encontraron servicios asignados</h4>
          <p>
            No existen registros asignados para este itinerario en esta
            categoría operativa.
          </p>
        </div>
      </ng-template>
    </ng-container>
  </mat-dialog-content>

  <!-- Modal Footer -->
  <div class="modal-footer">
    <button
      mat-flat-button
      type="button"
      class="btn-close-modal"
      (click)="handleCloseModal()"
    >
      Cerrar
    </button>
  </div>
</div>
